import { render, staticRenderFns } from "./detatilTitle.vue?vue&type=template&id=5187fd3c&scoped=true&"
import script from "./detatilTitle.vue?vue&type=script&lang=js&"
export * from "./detatilTitle.vue?vue&type=script&lang=js&"
import style0 from "./detatilTitle.vue?vue&type=style&index=0&id=5187fd3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187fd3c",
  null
  
)

export default component.exports